import type { Transaction, VersionedTransaction } from '@solana/web3.js';

export const isVersionedTransaction = (
  transaction: VersionedTransaction | Transaction
): transaction is VersionedTransaction => !('instructions' in transaction);
